module.exports = __webpack_public_path__ + "static/media/c8bannerModul2_small.5c641cd9.jpg";